import React, { type FC } from "react";
import { useParams } from "react-router-dom";
import AICLayout from "src/components/AICLayout/AICLayout";
import { DocumentComplianceContextProvider } from "src/components/Contexts/DocumentComplianceContext";
import { InboundDocumentContextProvider } from "src/components/Contexts/InboundDocumentContext";
import { UserActionsMetadataContextProvider } from "src/components/Contexts/UserActionsMetadata/Provider";
import { ValidationResultsContextProvider } from "src/components/Contexts/ValidationResultsContext";
import { DocumentComplianceHelperProvider } from "src/components/Pages/DocumentInbound/DocumentComplianceHelper/DocumentComplianceHelperContext";
import DocumentComplianceHelperPanel from "src/components/Pages/DocumentInbound/DocumentComplianceHelper/DocumentComplianceHelperPanel";
import InboundDocumentFetcher from "src/components/Pages/DocumentInbound/InboundDocumentFetcher";
import InboundDocumentHeader from "src/components/Pages/DocumentInbound/InboundDocumentHeader";
import InboundDocumentNavbar from "src/components/Pages/DocumentInbound/InboundDocumentNavbar";
import { usePageTitle } from "src/components/Title/usePageTitle";
import styles from "src/styles.module.scss";

const InboundDocument: FC = () => {
  const { countryCode, documentType, documentId, inboundDocumentTab } =
    useParams();

  usePageTitle(`${countryCode}::${documentType}::${documentId}`, false);

  return (
    <AICLayout
      disableCountryChange
      fixedCountry={countryCode}
      disableUrlSearchParamsUpdate
    >
      <InboundDocumentContextProvider>
        <InboundDocumentFetcher
          countryCode={countryCode!}
          documentId={documentId!}
          documentType={documentType!}
        />
        <DocumentComplianceContextProvider>
          <ValidationResultsContextProvider>
            <UserActionsMetadataContextProvider>
              <DocumentComplianceHelperProvider>
                <div className={styles.ma_10}>
                  <InboundDocumentHeader />
                  <InboundDocumentNavbar
                    inboundDocumentTab={inboundDocumentTab}
                  />
                </div>
                <DocumentComplianceHelperPanel />
              </DocumentComplianceHelperProvider>
            </UserActionsMetadataContextProvider>
          </ValidationResultsContextProvider>
        </DocumentComplianceContextProvider>
      </InboundDocumentContextProvider>
    </AICLayout>
  );
};

export default InboundDocument;
